import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import {
  getLawyerWorkload,
  updatePublicProfile,
  type PublicProfileUpdate,
} from '../../services/collaborators/lawyerProfileService';

export function useLawyerWorkload(collaboratorId: string | undefined) {
  return useQuery({
    ...STATIC,
    queryKey: ['lawyer-workload', collaboratorId],
    queryFn: () => getLawyerWorkload(collaboratorId!),
    enabled: !!collaboratorId,
  });
}

export function useUpdatePublicProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, update }: { id: string; update: PublicProfileUpdate }) =>
      updatePublicProfile(id, update),
    onSuccess: (_data, { id }) => {
      qc.invalidateQueries({ queryKey: ['collaborators'] });
      qc.invalidateQueries({ queryKey: ['collaborators', id] });
      qc.invalidateQueries({ queryKey: ['lawyer-workload', id] });
    },
  });
}
